export const IconeInstagram = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8099 8.41992C22.0299 8.41992 21.3999 9.04992 21.3999 9.82992C21.3999 10.6099 22.0299 11.2399 22.8099 11.2399C23.5899 11.2399 24.2199 10.6099 24.2199 9.82992C24.2199 9.04992 23.5899 8.41992 22.8099 8.41992Z"
        fill="#F5F5F5"
      />
      <path
        d="M16.54 9.75C13.09 9.75 10.29 12.55 10.29 16C10.29 19.45 13.09 22.25 16.54 22.25C19.99 22.25 22.79 19.45 22.79 16C22.79 12.55 19.99 9.75 16.54 9.75ZM16.54 20.01C14.33 20.01 12.54 18.21 12.54 16.01C12.54 13.81 14.34 12.01 16.54 12.01C18.74 12.01 20.54 13.81 20.54 16.01C20.54 18.21 18.74 20.01 16.54 20.01Z"
        fill="#F5F5F5"
      />
      <path
        d="M21.27 4H11.73C7.74 4 4.5 7.24 4.5 11.23V20.77C4.5 24.76 7.74 28 11.73 28H21.27C25.26 28 28.5 24.76 28.5 20.77V11.23C28.5 7.24 25.26 4 21.27 4ZM26.24 20.77C26.24 23.51 24.02 25.73 21.27 25.73H11.73C8.99 25.73 6.76 23.51 6.76 20.77V11.23C6.76 8.49 8.98 6.27 11.73 6.27H21.27C24.01 6.27 26.24 8.49 26.24 11.23V20.77Z"
        fill="#F5F5F5"
      />
    </svg>
  );
};
